import { WORKFLOW_BLOCK_TYPE } from "../../../../../../../src/shared/types/workflows";
import { STORY_BIBLE_KEYS } from "../../../../../../../src/shared/schemas/PluginSchema";

export const getAvailableVariables = (blocks: any[], targetBlockId: string) => {
  const availableVariables = new Set();
  availableVariables.add("MUSE_PROMPT_INJECTION_GUARD");
  let foundTargetBlock = false;
  blocks.forEach((block) => {
    if (block.id === targetBlockId || foundTargetBlock) {
      foundTargetBlock = true;
      return;
    }
    if (block.blockType === WORKFLOW_BLOCK_TYPE.API_INPUT) {
      const variables = block.options.variables.map((v: any) => v.name);
      variables.forEach((variable: string) => availableVariables.add(variable));
    }
    if (block.blockType === WORKFLOW_BLOCK_TYPE.INPUT_DOCUMENT) {
      availableVariables.add("previous_document_text");
    }
    if (block.blockType === WORKFLOW_BLOCK_TYPE.POV_AND_TENSE) {
      availableVariables.add("pov_value");
      availableVariables.add("tense_value");
      availableVariables.add("pov_characters");
    }
    if (block.blockType === WORKFLOW_BLOCK_TYPE.INPUT_STORY_BIBLE) {
      STORY_BIBLE_KEYS.forEach((variable) => availableVariables.add(variable));
    }
    if (block.blockType === WORKFLOW_BLOCK_TYPE.INFERENCE) {
      const outputName = block.options.outputName;
      availableVariables.add(outputName);
    }
    if (block.blockType === WORKFLOW_BLOCK_TYPE.AB_TEST) {
      availableVariables.add(block.options.experimentName);
    }
  });
  return Array.from(availableVariables);
};

export type OverrideGroup = {
  group: string;
  name: string;
  availableValues?: string[];
};

export const getOverrideOptions = (blocks: any[], targetBlockId: string): OverrideGroup[] => {
  const optionGroups: OverrideGroup[] = [];
  const abTestBlocks = blocks.filter((block) => block.blockType === WORKFLOW_BLOCK_TYPE.AB_TEST);
  const variablesBlocks = blocks.filter((block) => block.blockType === WORKFLOW_BLOCK_TYPE.API_INPUT);
  const storyBibleBlock = blocks.find((block) => block.blockType === WORKFLOW_BLOCK_TYPE.INPUT_STORY_BIBLE);
  const featureFlagsBlock = blocks.find((block) => block.blockType === WORKFLOW_BLOCK_TYPE.FEATURE_FLAGS);
  const targetBLockIndex = blocks.findIndex((block) => block.id === targetBlockId);
  const inferenceBLocksBeforeTarget = blocks.slice(0, targetBLockIndex - 1).filter((block) => block.blockType === WORKFLOW_BLOCK_TYPE.INFERENCE);

  if (featureFlagsBlock) {
    const flags = featureFlagsBlock.options.subscriptionFeatureFlags.map((flag: any) => flag.name);
    for (const flag of flags) {
      optionGroups.push({
        group: "Feature Flags",
        name: flag,
        availableValues: ["true", "false"],
      });
    }
  }

  for (const block of abTestBlocks) {
    const experimentName = block.options.experimentName;
    const values = [block.options.controlVariationName, block.options.testVariationName];
    optionGroups.push({
      group: "A/B Tests",
      name: experimentName,
      availableValues: values,
    });
  }

  for (const block of variablesBlocks) {
    const variables = block.options.variables.map((v: any) => v.name);
    for (const variable of variables) {
      optionGroups.push({
        group: "Variables",
        name: variable,
      });
    }
  }
  if (storyBibleBlock) {
    for (const key of STORY_BIBLE_KEYS) {
      optionGroups.push({
        group: "Story Bible",
        name: key,
      });
    }
  }
  for (const block of inferenceBLocksBeforeTarget) {
    const outputName = block.options.outputName;
    optionGroups.push({
      group: "Inference",
      name: outputName,
    });
  }
  return optionGroups;
};
